export const site = {
  name: "爆点观察局",
  slogan: "全网黑料网爆与热点扩散观察站",
  intro:
    "我们记录话题从出现、被搬运、登上热搜到全网被传疯的完整轨迹，用数据和事实层级还原一次热点扩散的全过程。",
  email: "hello@baodian-insight.example",
  updateNote: "榜单每 15 分钟刷新一次 · 复盘记录保留 7 天",
  nav: [
    { label: "首页", to: "/" },
    { label: "热搜榜", to: "/ranking" },
    { label: "深度追踪", to: "/#deep" },
    { label: "常见问题", to: "/#faq" },
    { label: "关于我们", to: "/about" },
  ],
  footerGroups: [
    {
      title: "站内导航",
      links: [
        { label: "首页", to: "/" },
        { label: "实时热搜榜", to: "/ranking" },
        { label: "深度追踪", to: "/#deep" },
        { label: "关于我们", to: "/about" },
      ],
    },
    {
      title: "热门风向",
      links: [
        { label: "综艺现场话题", to: "/ranking?c=variety" },
        { label: "影视片场话题", to: "/ranking?c=screen" },
        { label: "网络风波话题", to: "/ranking?c=storm" },
        { label: "电竞圈话题", to: "/ranking?c=esports" },
      ],
    },
    {
      title: "内容原则",
      links: [
        { label: "话题匿名化说明", to: "/about#principle" },
        { label: "数据统计口径", to: "/about#data" },
        { label: "常见问题", to: "/#faq" },
        { label: "纠错与投稿", to: "/about#contact" },
      ],
    },
  ],
};

export const tagStyles: Record<string, string> = {
  爆: "bg-primary-500 text-background-50",
  沸: "bg-primary-100 text-primary-800",
  热: "bg-accent-500 text-foreground-950",
  新: "bg-accent-100 text-accent-900",
  荐: "bg-secondary-100 text-secondary-900",
};